export default "__VITE_ASSET__BQi3$NpW__"